define('components/course/models/slide-type/video-intro',[
    'components/course/models/slide-type/base'
], function (Base) {
    "use strict";

    return Base.extend({
        "defaults": function () {
            var baseDefaults = Base.prototype.defaults.call(this),
                defaults;

            defaults = {
                "data": {
                    "backgroundImage": null,
                    "description": null,
                    "displayTitle": null
                }
            };

            return _.extend(baseDefaults, defaults);
        }
    });
});

